<template>
  <data-table
    :header="table.header"
    class="available-documents-data-table"
  >
    <div
      v-for="(body, docIndex) in table.body"
      :key="docIndex"
      class="data-table__body__row"
    >
      <data-cell :size="30">
        <h3 class="overflow-text align-vertically">
          <md-tooltip>{{ body[0].fileName }}</md-tooltip>
          {{ body[0].fileName }}
        </h3>
      </data-cell>
      <data-cell :size="40">
        <h4 class="overflow-text align-vertically">
          <span
            v-for="(exam, index) in body"
            :key="index"
          >
            {{ exam.examName }}<span v-if="index + 1 < body.length">, </span>
          </span>
          <md-tooltip class="tooltip-small">
            <span
              v-for="(exam, index) in body"
              :key="index"
            >
              {{ exam.examName }}<span v-if="index + 1 < body.length">, </span>
            </span>
          </md-tooltip>
        </h4>
      </data-cell>
      <data-cell
        :size="25"
        class="button-container"
      >
        <md-button
          class="btn btn-secondary button"
          @click="preview(body[0])"
        >
          Visualizar
        </md-button>
      </data-cell>
    </div>
  </data-table>
</template>

<script>
import DataTable from '../common/dataTable/DataTable'
import DataCell from '../common/dataTable/DataCell'
import DataShowOff from '../common/dataTable/DataShowOff'
import documentManagementService from '@/api/documentManagement'
import notify from '@/api/notification'
import { convertBase64ToFile } from '@/utils/convertBase64ToFile'

export default {
  name: 'AvailableDocumentsDataTable',
  components: {
    'data-table': DataTable,
    'data-cell': DataCell,
    'data-showoff': DataShowOff
  },
  props: {
    documents: {
      type: Object
    }
  },
  data () {
    return {
      table: {
        header: [
          {
            title: 'Documentos',
            size: 30
          },
          {
            title: 'Exames Associados',
            size: 30
          },
          {
            size: 15
          }
        ],
        body: []
      }
    }
  },
  watch: {
    documents: function (newValue) {
      this.table.body = newValue
    }
  },
  created () {
    this.table.body = this.documents
  },
  methods: {
    preview (document) {
      notify({
        title: 'AVISO:',
        message: 'Abrindo visualização do arquivo...'
      })
      documentManagementService
        .downloadDocumentByUuid(document.documentTemplateUuid)
        .then((response) => {
          let fileName = document.fileName
          let fileExtension = fileName.split('.')[1]

          if (!this.isIE() && fileExtension === 'pdf') {
            let file = new Blob([response.data], {
              type: 'application/' + fileExtension
            })
            let fileURL = URL.createObjectURL(file)
            window.open(fileURL)
          } else {
            convertBase64ToFile({
              file: response,
              fileName: fileName,
              fileExtension: fileExtension
            })
          }
        })
        .catch(() => {
          notify({
            title: 'AVISO:',
            message: 'Não foi possível visualizar o documento.'
          })
        })
    },
    isIE () {
      let ua = navigator.userAgent
      let isIEBrowser = ua.indexOf('MSIE ') > -1 || ua.indexOf('Trident/') > -1

      return isIEBrowser
    }
  }
}
</script>

<style lang="scss">
.available-documents-data-table {
  flex-wrap: unset !important;

  .data-table {
    &__body__row {
      height: auto;

      &__cell {
        font-family: Roboto, sans-serif;
        font-style: normal;
        table-layout: fixed;
        display: table;
        height: auto;
        margin: auto;

        @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
          /* IE10 & IE11 CSS styles go here */
          height: 100% !important;
        }
      }

      &__cell button {
        width: 200px;
        padding-top: 5px;
        padding-bottom: 10px;
        padding-left: 5px;
        cursor: pointer;
      }
    }
  }

  h3 {
    font-family: Roboto, sans-serif;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 26px;
  }

  h4 {
    font-weight: normal;
    font-size: 16px;
  }

  .overflow-text {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .align-vertically {
    display: table-cell;
    vertical-align: middle;
  }

  .button-container {
    height: auto;
    margin: auto 22px;

    .md-button {
      width: 100%;
      padding-top: initial;
      padding-bottom: initial;
      height: 36px;
    }
  }
}

.tooltip-small {
  max-width: 310px;
  white-space: initial;
}
</style>
